import CloseSvg from "src/components/svg/CloseSvg";
import classNames from 'classnames';
import { useEffect, useRef, useState } from "react";
import styles from './FlyoutPanel.module.css';

//#region [Props]
type FlyoutPanelProps = {
	children: React.ReactNode;
	onAfterCloseComplete?: () => void;
	isClosed?: boolean;
};
//#endregion

//#region [Component]
export default function FlyoutPanel({ children, onAfterCloseComplete, isClosed = false }: FlyoutPanelProps) {
	const [isOpen, setIsOpen] = useState(false);
	const isMounting = useRef(true);

	useEffect(() => {
		// start initial animation AFTER first render
		setIsOpen(true);
	}, []);

	useEffect(() => {
		if (!isMounting.current && onAfterCloseComplete && !isOpen) {
			const id = setTimeout(() => onAfterCloseComplete(), 550);
			return () => {
				clearTimeout(id);
			};
		}
		isMounting.current = false;
	}, [onAfterCloseComplete, isOpen]);

	useEffect(() => {
		if (isClosed) {
			setIsOpen(false);
		}
	}, [isClosed]);

	return (
		<div className={classNames(styles.flyoutPanel, { [styles.open]: isOpen })}>
			<div className={classNames(styles.interactionContainer, { [styles.open]: isOpen })}>
				<button className={styles.closeButton} onClick={() => setIsOpen(false)}><CloseSvg /></button>
				{children}
			</div>
		</div>
	);
}
//#endregion
